import { GET_CONSTITUENCIES, GET_CONSTITUENCIES_FAIL, GET_CONSTITUENCIES_SUCCESS, GET_COUNTIES, GET_COUNTIES_FAIL, GET_COUNTIES_SUCCESS, GET_REGIONS, GET_REGIONS_FAIL, GET_REGIONS_SUCCESS, GET_WARDS, GET_WARDS_FAIL, GET_WARDS_SUCCESS } from './actionTypes';

export const getCounties = (payload) => ({
    payload,
    type: GET_COUNTIES,
});

export const getCountiesSuccess = (counties) => ({
    type: GET_COUNTIES_SUCCESS,
    payload: counties,
});

export const getCountiesFail = (error) => ({
    type: GET_COUNTIES_FAIL,
    payload: error,
});

export const getSubCounties = (payload) => ({
    payload,
    type: GET_CONSTITUENCIES,
});

export const getSubCountiesSuccess = (data) => ({
    type: GET_CONSTITUENCIES_SUCCESS,
    payload: data,
});

export const getSubCountiesFail = (error) => ({
    type: GET_CONSTITUENCIES_FAIL,
    payload: error,
});

export const getRegions = (payload) => ({
    payload,
    type: GET_REGIONS,
});

export const getRegionsSuccess = (data) => ({
    type: GET_REGIONS_SUCCESS,
    payload: data,
});

export const getRegionsFail = (error) => ({
    type: GET_REGIONS_FAIL,
    payload: error,
});

export const getWards = (payload) => ({
    payload,
    type: GET_WARDS,
});

export const getWardsSuccess = (counties) => ({
    type: GET_WARDS_SUCCESS,
    payload: counties,
});

export const getWardsFail = (error) => ({
    type: GET_WARDS_FAIL,
    payload: error,
});